/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-extraneous-dependencies */
import { createRef, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Card, CardContent, CardDescription } from "@repo/ui";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";
import { MdUpdate } from "react-icons/md";
import { Loader2 } from "lucide-react";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { PATHS } from "routes/paths";
import {
  useExportCashTickets,
  useGetCashTickets,
  useGetTasks,
} from "services/tickets";
import Loader from "ui/page-loader";
import { BreadCrumb } from "ui/bread-crumbs";
import { FiltersContext } from "store/filters-context";
import UpdateStatus from "../ticketDetails/update-status";
import { StatusContext } from "../constants";
import {
  fixKendoGridContent,
  getTicketDetailsPage,
  isFilterUpdated,
} from "../utils";
import FilterBarV2 from "../common/filter-bar";
import GridDataCopyCell from "components/copy";
import SLACell from "../common/SLACell";

export default function CCACashTicketsList() {
  const [dataState, setDataState] = useState({
    sort: [
      {
        field: "code",
        dir: "asc",
      },
    ],
  });
  const getSlaStageInfo = (value) => {
    let display = value;
    let bgColor = "transparent";

    switch (value) {
      case "WithinSla":
        display = "Within SLA";
        bgColor = "#2A9D8F";
        break;
      case "Breached":
      case "BreachEscalation":
        display = "Breached Escalation";
        bgColor = "#E63946";
        break;
      case "AboutToBreach":
        display = "About to Breach";
        bgColor = "#f59e0b";
        break;
      default:
        display = value;
        bgColor = "transparent";
    }

    return { display, bgColor };
  };
  const [tickets, setTickets] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [reload, setReload] = useState(false);

  const { filters } = useContext(FiltersContext);
  const [localFilters, setLocalFilters] = useState({
    searchCriteria: filters?.searchCriteria?.value || "",
    period: filters?.period?.value || "All",
    cashCenterId: filters?.cashCenterId?.value || "",
    customerId: filters?.customerId?.value || "",
    assetId: filters?.assetId?.value || "",
    activityType: filters?.activityType?.value || "",
    assignmentGroup: filters?.assignmentGroup?.value || "",
  });
  const { setStatus } = useContext(StatusContext);

  const pageSize = 100;
  const _exporter = createRef();

  useEffect(() => {
    const nextFilters = {
      searchCriteria: filters?.searchCriteria?.value || "",
      period: filters?.period?.value || "All",
      cashCenterId: filters?.cashCenterId?.value || "",
      customerId: filters?.customerId?.value || "",
      assetId: filters?.assetId?.value || "",
      activityType: filters?.activityType?.value || "",
      assignmentGroup: filters?.assignmentGroup?.value || "",
    };

    if (isFilterUpdated(localFilters, nextFilters)) {
      setLocalFilters({ ...nextFilters });
    }
  }, [filters]);

  const {
    mutate: getTickets,
    data: ticketsList,
    isPending: gettingTickets,
    reset: resetGetTickets,
  } = useGetCashTickets();

  const {
    mutate: getTasks,
    data: tasksList,
    isPending: gettingTasks,
    reset: resetTaskList,
  } = useGetTasks();

  const {
    mutate: getAllTickets,
    data: allTicketsData,
    isPending: gettingAllTickets,
    reset: getAllTicketsReset,
  } = useExportCashTickets();

  useEffect(() => {
    if (allTicketsData) {
      excelExport();
      getAllTicketsReset();
    }
  }, [allTicketsData]);

  useEffect(() => {
    setCurrentPage(1);
    getTickets({
      pageNumber: 1,
      pageRowCount: pageSize,
      ...localFilters,
    });
  }, [reload, localFilters]);

  useEffect(() => {
    if (ticketsList) {
      setTotalRecords(ticketsList.data.totalRecords);
      setTickets(
        ticketsList.data.data.map((elm) => ({
          ...elm,
          expanded: false,
          selected: false,
          vaultAccessRequired: elm.vaultAccessRequired ? "Yes" : "No",
          vaultAccessAdded: elm.vaultAccessAdded ? "Yes" : "No",
          responseSlaStage: getSlaStageInfo(elm?.responseSla?.slaStage).label,
          resolutionSlaStage: getSlaStageInfo(elm?.resolutionSla?.slaStage)
            .label,
        })),
      );
      resetGetTickets();
    }
  }, [ticketsList]);

  const onPageChange = (e) => {
    const _page = e.page.skip / pageSize + 1;
    setCurrentPage(_page);
    getTickets({
      pageNumber: _page,
      pageRowCount: pageSize,
      ...localFilters,
    });
  };
  const onRefresh = () => {
    getTickets({
      pageNumber: currentPage,
      pageRowCount: pageSize,
      ...localFilters,
    });
  };

  const updateCell = ({ dataItem }) => {
    return (
      <td>
        <div
          className="flex items-center justify-center w-full"
          title="Update Status"
        >
          <UpdateStatus
            triggerButton={
              <Button variant="outline">
                <MdUpdate
                  fontSize="18px"
                  className="text-primary font-[18px]"
                />
              </Button>
            }
            onReload={() => {
              setReload(!reload);
            }}
            requestDetails={dataItem}
          />
        </div>
      </td>
    );
  };

  const excelExport = () => {
    if (_exporter.current) {
      _exporter.current.save();
    }
  };

  const onExpandChange = ({ dataItem }) => {
    const _tickets = [...tickets];
    _tickets.forEach((elm, index) => {
      if (elm.ticketId === dataItem.ticketId) {
        _tickets[index].expanded = !elm.expanded;
      } else {
        elm.expanded = false;
      }
    });

    setTickets(_tickets);
    resetTaskList();
    getTasks(dataItem.ticketId);
  };
  function DetailComponent() {
    if (gettingTasks) {
      return <Loader2 />;
    }
    return (
      <div style={{ background: "white", padding: "12px" }}>
        <h1 className="text-md font-medium">Tasks List</h1>
        <Grid
          data={tasksList?.data || []}
          style={{ margin: "20px 0", background: "white" }}
          className="detail-grid border-2"
        >
          <GridColumn
            title="Task Number"
            width="170px"
            filterable={false}
            field="taskNo"
            cell={(items) => {
              const dataItem = items.dataItem;
              return (
                <GridDataCopyCell
                  dataItem={items.dataItem}
                  field={items.field}
                  customCell={
                    <td>
                      <Link
                        onClick={() => {
                          setStatus("all");
                        }}
                        to={`${PATHS.taskDetails}/${dataItem.requestId}`}
                      >
                        {dataItem.status === "Draft"
                          ? "View Draft"
                          : dataItem.taskNo}
                      </Link>
                    </td>
                  }
                />
              );
            }}
          />
          <GridColumn
            title="Vault Access Required"
            field="vaultAccessRequired"
            cell={(items) => {
              return (
                <GridDataCopyCell
                  dataItem={items.dataItem}
                  field={items.field}
                  customCell={
                    <td>{items.dataItem.vaultAccessRequired ? "Yes" : "No"}</td>
                  }
                />
              );
            }}
            width="170px"
          />
          <GridColumn
            title="Vault Access Added"
            field="vaultAccessAdded"
            cell={(items) => {
              return (
                <GridDataCopyCell
                  dataItem={items.dataItem}
                  field={items.field}
                  customCell={
                    <td>{items.dataItem.vaultAccessAdded ? "Yes" : "No"}</td>
                  }
                />
              );
            }}
            width="170px"
          />
          <GridColumn
            title="Assignment Group"
            field="assignmentGroup"
            width="170px"
          />
          <GridColumn title="Route No" field="routeNo" width="170px" />
          <GridColumn title="Assigned To" field="assigneeId" width="170px" />
          <GridColumn
            title="Secondary Assignee"
            field="secondaryAssigneeId"
            width="170px"
          />
          <GridColumn title="State" field="status" width="150px" />
          <GridColumn
            title="Resolution Code"
            field="resolutionCode"
            width="170px"
          />
          <GridColumn
            title="Resolution Details"
            field="resolutionDetails"
            width="170px"
          />
          <GridColumn
            title="Description"
            field="remarks"
            width="400px"
            cell={GridDataCopyCell}
          />
          <GridColumn
            title="Response SLA Stage"
            field="responseSlaStage"
            width="170px"
            headerClassName="text-center"
            className="text-center"
            cell={(items) => {
              const { display, bgColor } = getSlaStageInfo(
                items.dataItem.responseSlaStage,
              );
              return (
                <td>
                  <div className="flex items-center justify-center">
                    {display ? (
                      <div
                        className="flex px-3 py-1 items-center justify-center text-sm font-medium rounded-md border"
                        style={{
                          width: "120px",
                          backgroundColor: bgColor,
                          color: bgColor === "transparent" ? "#374151" : "#fff",
                        }}
                      >
                        {display}
                      </div>
                    ) : null}
                  </div>
                </td>
              );
            }}
          />
          <GridColumn
            title="Resolution SLA Stage"
            field="resolutionSlaStage"
            width="170px"
            headerClassName="text-center"
            className="text-center"
            cell={(items) => {
              const { display, bgColor } = getSlaStageInfo(
                items.dataItem.resolutionSlaStage,
              );
              return (
                <td>
                  <div className="flex items-center justify-center">
                    {display ? (
                      <div
                        className="flex px-3 py-1 items-center justify-center text-sm font-medium rounded-md border"
                        style={{
                          width: "120px",
                          backgroundColor: bgColor,
                          color: bgColor === "transparent" ? "#374151" : "#fff",
                        }}
                      >
                        {display}
                      </div>
                    ) : null}
                  </div>
                </td>
              );
            }}
          />

          <GridColumn title="Reason" field="reasons" width="170px" />
        </Grid>
      </div>
    );
  }

  return (
    <div className="box-border">
      {gettingTickets ? <Loader /> : <></>}
      <BreadCrumb
        className="mx-4"
        items={[
          { text: "Dashboard", to: "/" },
          { text: "Open Tickets (Cash)" },
        ]}
      />
      <Card className="mx-4 mt-5">
        <CardContent>
          <CardDescription className="pt-6">
            <FilterBarV2
              exportExcel
              exportingExcel={gettingAllTickets}
              onRefresh={onRefresh}
              hideStatus
              onExcelExport={() => {
                getAllTickets({
                  status: "All",
                  ...localFilters,
                });
              }}
              pageType="service"
            />
          </CardDescription>

          <Grid
            data={process(
              tickets.map((item) => ({
                ...item,
              })),
              dataState,
            )}
            {...dataState}
            filterable
            className="list-tables-v1"
            width="100%"
            sortable
            pageable
            navigatable
            total={totalRecords}
            pageSize={pageSize}
            skip={(currentPage - 1) * pageSize}
            onPageChange={onPageChange}
            expandField="expanded"
            onDataStateChange={(e) => {
              setDataState(e.dataState);
            }}
            onExpandChange={onExpandChange}
            detail={DetailComponent}
            ref={(e) => {
              fixKendoGridContent(e);
            }}
          >
            <GridColumn
              title="Update"
              filterable={false}
              cell={updateCell}
              width="100px"
            />
            <GridColumn
              title="Open At"
              field="createDateTime"
              width="120px"
              className="text-center"
              headerClassName="text-center"
            />
            <GridColumn
              title="Resolve At"
              field="resolvedDateTime"
              width="120px"
              className="text-center"
              headerClassName="text-center"
            />
            <GridColumn
              title="Duration"
              headerClassName="text-center"
              field="sla"
              width="150px"
              cell={SLACell}
            />
            <GridColumn
              title="State"
              field="status"
              width="150px"
              className="text-center"
              headerClassName="text-center"
              filterable
            />

            <GridColumn title="Account" field="customer" width="170px" />
            <GridColumn title="Asset Id" field="locationId" width="150px" />
            <GridColumn
              title="Ticket Number"
              width="170px"
              field="caseNo"
              cell={(items) => {
                const dataItem = items.dataItem;

                return (
                  <GridDataCopyCell
                    dataItem={items.dataItem}
                    field={items.field}
                    customCell={
                      <td>
                        <Link
                          onClick={() => {
                            setStatus("cash");
                          }}
                          to={getTicketDetailsPage(dataItem)}
                        >
                          {dataItem.status === "Draft"
                            ? "View Draft"
                            : dataItem.caseNo}
                        </Link>
                      </td>
                    }
                  />
                );
              }}
            />

            <GridColumn
              title="Bank Reference/Address"
              field="customerTicketNo"
              width="200px"
            />
            <GridColumn
              title="Activity Type"
              field="activityType"
              width="170px"
            />
            <GridColumn title="Category" field="category" width="150px" />
            <GridColumn
              title="Sub Category"
              field="subCategory"
              width="150px"
            />
            <GridColumn title="Location" field="locationName" width="170px" />
            <GridColumn title="Region" field="region" width="150px" />
            <GridColumn
              title="Assignment Group"
              field="assignmentGroup"
              width="170px"
            />

            <GridColumn title="Reported By" field="reportedBy" width="170px" />
            <GridColumn
              title="Description"
              field="remarks"
              width="400px"
              cell={GridDataCopyCell}
            />
            <GridColumn
              title="Resolution Notes"
              field="resolutionNotes"
              width="170px"
              cell={GridDataCopyCell}
            />
          </Grid>
          <ExcelExport
            data={allTicketsData?.data.data || []}
            fileName="Cash_Tickets.xlsx"
            ref={_exporter}
          >
            <GridColumn
              title="Created At"
              field="createDateTime"
              width="170px"
            />
            <GridColumn title="State" field="status" width="200px" />
            <GridColumn title="Account" field="customer" width="170px" />
            <GridColumn title="Asset Id" field="locationId" width="150px" />
            <GridColumn title="Ticket Number" width="170px" field="caseNo" />

            <GridColumn
              title="Bank Reference/Address"
              field="customerTicketNo"
            />
            <GridColumn
              title="Activity Type"
              field="activityType"
              width="170px"
            />
            <GridColumn title="Category" field="category" width="150px" />
            <GridColumn
              title="Sub Category"
              field="subCategory"
              width="150px"
            />
            <GridColumn title="Location" field="locationName" width="170px" />
            <GridColumn title="Region" field="region" width="150px" />
            <GridColumn
              title="Assignment Group"
              field="assignmentGroup"
              width="170px"
            />
            <GridColumn title="Reported By" field="reportedBy" width="170px" />
            <GridColumn title="Description" field="remarks" width="170px" />
            <GridColumn
              title="Resolution Notes"
              field="resolutionNotes"
              width="170px"
            />

            <GridColumn title="Opened By" field="openedBy" width="170px" />
          </ExcelExport>
        </CardContent>
      </Card>
    </div>
  );
}
